// extracted by mini-css-extract-plugin
export default {"value":"iconValue_value__RPL8m","text":"iconValue_text__nLH+z"};